import { FunctionComponent } from "react"
import { ColElement } from "types"

export const Col: FunctionComponent<ColElement> = (props) => (
    <div className={`col-flex ${props.class}`}>
        {props.children}
    </div>
);

export const ColLeft: FunctionComponent<ColElement> = (props) => (
    <div className={`col-flex__left ${props.class}`}>
        {props.children}
    </div>
);

export const ColRight: FunctionComponent<ColElement> = (props) => (
    <div className={`col-flex__right ${props.class}`}>
        {props.children}
    </div>
);

